'use strict';

var _ = require('lodash');

var appPartMediaInnerViewNameUtils = {
    getMediaInnerViewNames: function getMediaInnerViewNames() {
        return ['FeaturedInner', 'FeaturedInnerMobile', 'MediaInner', 'MediaInnerCustom', 'PostsListMediaInner', 'SinglePostMediaInner'];
    },
    isMediaInnerViewName: function isMediaInnerViewName(viewName) {
        var mediaInnerViewNames = appPartMediaInnerViewNameUtils.getMediaInnerViewNames();
        return _.includes(mediaInnerViewNames, viewName);
    }
};

module.exports = appPartMediaInnerViewNameUtils;
//# sourceMappingURL=appPartMediaInnerViewNameUtils.js.map